import React from 'react';
import { View } from 'modules/styled/web';

export const CountUpContainer = ({ sx, children }) => (
  <View
    sx={{
      flex: 1,
      justifyContent: 'center',
      flexDirection: 'row',
      alignItems: 'center',
      ...sx,
    }}
  >
    {children}
  </View>
);
